import { useEffect, useState } from 'react';
import axios from 'axios';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { color } from 'framer-motion';


const VillageDetails = ({ gaonSrNo }) => {
  const [villageData, setVillageData] = useState(null);
  const [visitPlaces, setVisitPlaces] = useState([]);
  const [gpSadasya, setgpSadasya] = useState([]);
  const [gpAdhikari, setgpAdhikari] = useState([]);
  const [othAdhikari, setothAdhikari] = useState([]);
  const [facilities, setfacilities] = useState([]);
  const [error, setError] = useState(null); // optional: for showing error
  const [showtalOfficeInfo, setShowtalOfficeInfo] = useState(false);
  const [showDistOfficeInfo, setShowDistOfficeInfo] = useState(false);
  
  useEffect(() => {
    AOS.init({ duration: 800 }); // animation duration in ms

    axios
    .get('https://mazagaon.co.in/api/get-visit-places.php', {
      params: { gaon_Sr_No: gaonSrNo },
    })
    .then((response) => {
      console.log('✅ Visit places:', response.data);
      setVisitPlaces(response.data);
    })
    .catch((err) => {
      console.error('❌ Error fetching visit places:', err);
    });

    axios
    .get('https://mazagaon.co.in/api/get-gp-sadasya.php', {
      params: { gaon_Sr_No: gaonSrNo },
    })
    .then((response) => {
      console.log('✅ GP Sadasya:', response.data);
      setgpSadasya(response.data);
    })
    .catch((err) => {
      console.error('❌ Error fetching gp sadasya:', err);
    });

    axios
    .get('https://mazagaon.co.in/api/get-gp-adhikari.php', {
      params: { gaon_Sr_No: gaonSrNo },
    })
    .then((response) => {
      console.log('✅ GP Adhikari:', response.data);
      setgpAdhikari(response.data);
    })
    .catch((err) => {
      console.error('❌ Error fetching gp Adhikari:', err);
    });

    axios
    .get('https://mazagaon.co.in/api/get-Oth-adhikari.php', {
      params: { gaon_Sr_No: gaonSrNo },
    })
    .then((response) => {
      console.log('✅ Other Adhikari:', response.data);
      setothAdhikari(response.data);
    })
    .catch((err) => {
      console.error('❌ Error fetching Other Adhikari:', err);
    });

    axios
    .get('https://mazagaon.co.in/api/get-facilities.php', {
      params: { gaon_Sr_No: gaonSrNo },
    })
    .then((response) => {
      console.log('✅ Facilities:', response.data);
      setfacilities(response.data);
    })
    .catch((err) => {
      console.error('❌ Error fetching Facilities:', err);
    });

    axios
      .get('https://mazagaon.co.in/api/get-village-details.php', {
        params: { sr_no: gaonSrNo },
      })
      .then((response) => {
        console.log('✅ Village data:', response.data);
        if (response.data.error) {
          setError('डेटा सापडला नाही');
          setVillageData(null);
        } else {
          setVillageData(response.data);
        }
      })
      .catch((err) => {
        console.error('❌ Error fetching data:', err);
        setError('डेटा मिळवण्यात अडचण आली');
      });
  }, [gaonSrNo]);

  if (error) {
    return <div className="panel error">{error}</div>;
  }

  if (!villageData) {
    return <div className="panel">Loading...</div>;
  }

  return (
    <div className="panel">
      <header className="bg-success text-white text-center pt-3 pb-0 position-relative data-aos='fade-up'">
        <div className="row pb-0">
            <div className="col-2 col-md-2">
                <img src={`https://mazagaon.co.in/${villageData.gaon_name}/img/logo.jpg`} alt="Village Logo" className="logo-img rounded-circle border border-white" />
            </div>
            <div className="col-10 col-md-10">
                <h1 className="mt-0">{villageData.gaon_displayname}</h1>
                <h3 className="mt-2" style={{color:'#ff0'}}>ग्रामपंचायत कार्यालय</h3>
                <h6 className="mt-2" style={{color:'#fcc'}}>ता. {villageData.taluka}, जि. {villageData.district}</h6>
            </div>
        </div>
      </header>

       {/* Cover Photo */}
      <div className="cover-photo data-aos='zoom-in'">
        <img src={`https://mazagaon.co.in/${villageData.gaon_name}/img/CoverPhoto.jpg`}  alt="Village Cover Photo" className="img-fluid w-100 object-fit-cover"/>
        {villageData.Speciality && (
          <div className="col-12" style={{marginTop: -100}}>
            <div className="speciality-blink">
              🌟 {villageData.Speciality}
            </div>
          </div>
        )}

      </div>
      
<div className="scroll-container mt-5 mb-0">
  <div className="scroll-content">
        <img src="" alt="" />
        <img src="" alt="" />
        <img src="" alt="" />
        <img src="" alt="" />
        <img src="" alt="" />
        <img src="" alt="" />
        <img src="" alt="" />
        <img src="" alt="" />
    <img src="https://mazagaon.co.in/images/tiranga.png" alt="tiranga" />
    <img src="https://mazagaon.co.in/images/satyamevjayate.png" alt="satyamevjayate" />
    <img src="https://mazagaon.co.in/images/MahGovt.png" alt="MahGovt" />
    <img src="https://mazagaon.co.in/images/G2.png" alt="CM" />
    <img src="https://mazagaon.co.in/images/sustainaiblegrowth.png" alt="sustainaiblegrowth" />
    <img src="https://mazagaon.co.in/images/tiranga.png" alt="tiranga" />
    <img src="https://mazagaon.co.in/images/satyamevjayate.png" alt="satyamevjayate" />
    <img src="https://mazagaon.co.in/images/MahGovt.png" alt="MahGovt" />
    <img src="https://mazagaon.co.in/images/G2.png" alt="CM" />
    <img src="https://mazagaon.co.in/images/sustainaiblegrowth.png" alt="sustainaiblegrowth" />
  </div>
</div>


        {/* Information Cards */}
      <div className="container my-5">
        <div className="row g-4">
        <div className="col-12">
        <div className="card shadow">
          <div className="card-body">
            <h5 className="card-title">☝🏼 माझ्या गावा बद्दल ..</h5>
            <div
              className="card-text description-text"
              dangerouslySetInnerHTML={{
                __html: villageData.Description.replace(/\n/g, '<br/>'),
              }}
            />
          </div>
        </div>
      </div>

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">📍 Location</h5>
                <p className="card-text">{villageData.gaon_displayname}, ता. {villageData.taluka}, जि. {villageData.district}, {villageData.state}, India</p>
              </div>
            </div>
          </div>
          
          {villageData.gmap && (
            <div className="col-12 my-4">
              <div className="card shadow">
                <div className="card-body">
                  <h5 className="card-title">🗺️ Google Map</h5>
                  <div style={{ position: 'relative', width: '100%', height: '300px', overflow: 'hidden', borderRadius: '12px' }}>
                    <iframe
                      src={villageData.gmap}
                      width="100%"
                      height="100%"
                      style={{ border: 0 }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Google Map"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">🌾 ग्रामपंचायत क्षेत्रफळ</h5>
                <p className="card-text">{villageData.area_sqkm}  वर्ग किमी.</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">🏢 वार्ड संख्या</h5>
                <p className="card-text">{villageData.no_of_wards}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">👥 कुटुंब संख्या</h5>
                <p className="card-text">{villageData.no_of_families}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">👥 पुरुष संख्या</h5>
                <p className="card-text">{villageData.no_of_male}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">👥 स्त्री संख्या</h5>
                <p className="card-text">{villageData.no_of_female}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 data-aos='fade-up'">
            <div className="card shadow">
              <div className="card-body">
                <h5 className="card-title">👥 एकूण लोकसंख्या</h5>
                <p className="card-text">{villageData.total_population}</p>
              </div>
            </div>
          </div>

          {facilities.length > 0 && (
            <div className="col-12 data-aos='fade-in'">
              <h5 className="card-title">🦸🏼 गावातील सुविधा</h5>
          
              <div className="col-md-6 data-aos='fade-in'" >
                <div className="card shadow">
                  <div className="card-body">
                  <table className="table table-striped">
                    {facilities.map((gfacilities, idx) => (
                      <tr className='row'>
                        <td>
                          <span className="suvidha h6">✅ {gfacilities.f_name}:  {gfacilities.f_type}</span>
                        </td>
                      </tr>
                    ))}
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}

          {visitPlaces.length > 0 && (
            <div className="col-12 data-aos='fade-up'">
              <h5 className="card-title">🏞️ प्रेक्षणीय स्थळे</h5>
            </div>
          )}
          {visitPlaces.map((place, idx) => (
            <div className="col-md-6 data-aos='fade-up'" key={idx}>
              <div className="card shadow">
                <div className="card-body">
                  <h5 className="card-title">{place.place_name}</h5>
                  {place.place_photo1 && (
                  <img
                    src={`https://mazagaon.co.in/${villageData.gaon_name}/img/places/${place.place_photo1}`}
                    alt={place.place_name}
                    className="img-fluid rounded mb-2"
                  />
                  )}
                  <div className="mb-0" style={{ whiteSpace: 'pre-line' }}>
                    {place.place_description}
                  </div>
                </div>
              </div>
            </div>
          ))}

          <hr/>

          <div className="col-12 data-aos='fade-in'">
            <div className='text-center'>
              <a href='https://www.maharashtra.gov.in/'><h3>महाराष्ट्र शासन</h3></a>
              <div className="photo-grid mt-3">
                <img src="https://mazagaon.co.in/images/MahGovt.png" alt="MahGovt" />
                <img src="https://mazagaon.co.in/images/CM.png" alt="CM" />
                <img src="https://mazagaon.co.in/images/sustainaiblegrowth.png" alt="sustainaiblegrowth" />
                <img src="https://mazagaon.co.in/images/DeputyCM1.png" alt="DeputyCM1" />
                <img src="https://mazagaon.co.in/images/DeputyCM2.png" alt="DeputyCM2" />
                <img src="https://mazagaon.co.in/images/gram-vikas-mantri.png" alt="gram-vikas-mantri" />
              </div>
            <h4 className='mt-4 mb-2'>🏢 वरिष्ठ कार्यालये माहिती बघा</h4>
              
            <button onClick={() => setShowDistOfficeInfo(true)} className="btn btn-warning">
              जिल्हा परिषद, नाशिक
            </button> &nbsp; &nbsp; 
            <button onClick={() => setShowtalOfficeInfo(true)} className="btn btn-info">
              पंचायत समिती, दिंडोरी
            </button>
            </div>
          </div>
          <hr/>
          
          {gpSadasya.length > 0 && (
            <div className="col-12 data-aos='fade-in'">
              <h5 className="card-title">🦸🏼 सन्माननीय ग्रामपंचायत पदाधिकारी</h5>
            </div>
          )}
          {gpSadasya.map((sadasya, idx) => (
            <div className="col-md-6 data-aos='fade-in'" key={idx}>
              <div className="card shadow">
                <div className="card-body">
                  <h4 className="card-title">{sadasya.sadasya_Designation}</h4>
                  <h5 >{sadasya.sadasya_name}</h5>
                  {sadasya.sadasya_photo && (
                  <img
                    src={`https://mazagaon.co.in/${villageData.gaon_name}/img/sadasya/${sadasya.sadasya_photo}`}
                    alt={sadasya.sadasya_name}
                    className="img-fluid rounded mb-2"
                  />
                  )}
                  <div>
                  {sadasya.email_id && (
                    <span>इ-मेल: {sadasya.email_id},</span>
                  )} 

                  {sadasya.sadasya_mobile && (
                    <div>
                    <a
                      href={`https://wa.me/91${sadasya.sadasya_mobile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success btn-sm"
                    >
                      व्हॉट्सॲप ओपन
                    </a> &nbsp; &nbsp; &nbsp;
                    <a
                      href={`tel:${sadasya.sadasya_mobile}`}
                      className="btn btn-warning btn-sm"
                    >
                      कॉल 📞 {sadasya.sadasya_mobile} 
                    </a>
                    </div>
                  )} 
                   <br/>
                  {sadasya.des_rcvd_date && (
                    <span>
                      पद प्राप्त दिनांक: {new Date(sadasya.des_rcvd_date).toLocaleDateString('en-GB')}
                    </span>
                  )}
                 
                  </div>
                </div>
              </div>
            </div>
          ))}

          {gpAdhikari.length > 0 && (
            <div className="col-12 data-aos='fade-in'">
              <h5 className="card-title">🦸🏼 सन्माननीय ग्रामपंचायत अधिकारी</h5>
            </div>
          )}
          {gpAdhikari.map((gadhikari, idx) => (
            <div className="col-md-6 data-aos='fade-in'" key={idx}>
              <div className="card shadow">
                <div className="card-body">
                  <h4 className="card-title">{gadhikari.adhik_Designation}</h4>
                  <h5>{gadhikari.adhik_name}</h5>
                  {gadhikari.adhik_photo && (
                  <img
                    src={`https://mazagaon.co.in/${villageData.gaon_name}/img/gadhikari/${gadhikari.adhik_photo}`}
                    alt={gadhikari.adhik_name}
                    className="img-fluid rounded mb-2"
                  />
                  )}
                  <div>
                  {gadhikari.email_id && (
                    <span>इ-मेल: {gadhikari.email_id},</span>
                  )} 

                  {gadhikari.adhik_mobile && (
                    <div>
                    <a
                      href={`https://wa.me/91${gadhikari.adhik_mobile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success btn-sm"
                      > 
                      व्हॉट्सॲप ओपन
                    </a> 
                    &nbsp; &nbsp; &nbsp;
                    <a
                      href={`tel:${gadhikari.adhik_mobile}`}
                      className="btn btn-warning btn-sm"
                    >
                      कॉल 📞 {gadhikari.adhik_mobile} 
                    </a>
                      </div>
                     )} 
                  </div>
                </div>
              </div>
            </div>
          ))}

          {othAdhikari.length > 0 && (
            <div className="col-12 data-aos='fade-in'">
              <h5 className="card-title">🦸🏼 इतर अधिकारी</h5>
            </div>
          )}
          {othAdhikari.map((oadhikari, idx) => (
            <div className="col-md-6 data-aos='fade-in'" key={idx}>
              <div className="card shadow">
                <div className="card-body">
                  <h4 className="card-title">{oadhikari.oth_Dept}</h4>
                  <h5><b>{oadhikari.oth_Designation}</b></h5>
                  <h5>{oadhikari.oth_name}</h5>
                  {oadhikari.oth_photo && (
                  <img
                    src={`https://mazagaon.co.in/${villageData.gaon_name}/img/oadhikari/${oadhikari.oth_photo}`}
                    alt={oadhikari.oth_name}
                    className="img-fluid rounded mb-2"
                  />
                  )}
                  <div>
                  {oadhikari.email_id && (
                    <span>इ-मेल: {oadhikari.email_id},</span>
                  )} 

                  {oadhikari.oth_mobile && (
                    <div>
                    <a
                      href={`https://wa.me/91${oadhikari.oth_mobile}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn btn-success btn-sm"
                      >
                      व्हॉट्सॲप ओपन
                    </a> 
                    &nbsp; &nbsp; &nbsp;
                    <a
                      href={`tel:${oadhikari.oth_mobile}`}
                      className="btn btn-warning btn-sm"
                    >
                      कॉल 📞 {oadhikari.oth_mobile} 
                    </a>
                      </div>
                     )} 
                  </div>
                </div>
              </div>
            </div>
          ))}


        <hr/>
        <div className="p-1 m-0" >
          <h5>हेल्प :</h5>
          <ul>
            <li>ह्या वेबसाईट चा मोबाईलवर शॉर्टकट कसा घ्यायचा? Video : &nbsp;
            <a href="https://youtube.com/shorts/iY1OHutKDPY?feature=share
" className="btn btn-danger" > ▶️ </a>  </li>
            <li>ह्या वेबसाईट च्या वापरासंबंधी संपूर्ण माहिती. Video : &nbsp;
            <a href="https://youtu.be/hATPST2vQoo" className="btn btn-danger" > ▶️ </a> </li>
          </ul>
        </div>

        <div className="ETSInfo p-1 m-0" >
          Developed by: Elinje Technosoft Pvt. Ltd., Nashik.&nbsp;
           <a href={`tel:8308130756`}
              className="btn btn-warning"
           > 
            कॉल 📞 8308130756 
           </a> 
        </div>
      </div>    
    </div>  

      {showtalOfficeInfo && (
        <div className="modal-overlay">
          <div className="modal-iframe-container">
            <button className="modal-close-button" onClick={() => setShowtalOfficeInfo(false)}>
              ✖
            </button>
            <iframe
              src="https://mazagaon.co.in/dindori_nashik.html"
              title="Senior Office Info"
              width="100%"
              height="100%"
              frameBorder="0"
            />
          </div>
        </div>
     )}

      {showDistOfficeInfo && (
        <div className="modal-overlay">
          <div className="modal-iframe-container">
            <button className="modal-close-button" onClick={() => setShowDistOfficeInfo(false)}>
              ✖
            </button>
            <iframe
              src="https://mazagaon.co.in/nashikdistrict.html"
              title="Senior Office Info"
              width="100%"
              height="100%"
              frameBorder="0"
            />
          </div>
        </div>
     )}
   
    </div>     
  );
};

export default VillageDetails;
